import Confirm from './main.vue'
const defaultC = {
  isShow: true,
  message: "default message",
  title: "Confirm",
  cancelTitle: "取消",
  okTitle: "确定",
  ok: null,
  cancel: null,
  close: null
};
export default {
  install(Vue) {
    const ConfirmConstructor = Vue.extend(Confirm);
    const instance = new ConfirmConstructor();
    instance.$mount()
    document.body.appendChild(instance.$el)
    Vue.prototype.$confirm = (options) => {
      Object.assign(instance, defaultC, options);
    }
  }
}